import {QuestionDifficulty} from '@domain/pom'
import {ApiClient} from '@hconnect/apiclient'

import {BackendQuestion, RequestFunc} from '../../types'

import {loggingDecorator} from './decorators'

const getQuestionsImpl: RequestFunc<
  {plantId: string; topicId: string; difficulty?: QuestionDifficulty},
  BackendQuestion[]
> = async ({plantId, topicId, difficulty}) => {
  const params = difficulty ? `?difficulty=${difficulty}` : ''
  const {data} = await ApiClient.axiosInstance.get<BackendQuestion[]>(
    `/pom-questionnaires/${plantId}/topics/${topicId}/questions${params}`
  )
  return data
}

export const getQuestions = loggingDecorator(getQuestionsImpl)
